/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Stem } from './Stem';
import {
    StemFromJSON,
    StemFromJSONTyped,
    StemToJSON,
} from './Stem';

/**
 * 
 * @export
 * @interface StemsResponse
 */
export interface StemsResponse {
    /**
     * 
     * @type {Array<Stem>}
     * @memberof StemsResponse
     */
    data?: Array<Stem>;
}

/**
 * Check if a given object implements the StemsResponse interface.
 */
export function instanceOfStemsResponse(value: object): value is StemsResponse {
    let isInstance = true;

    return isInstance;
}

export function StemsResponseFromJSON(json: any): StemsResponse {
    return StemsResponseFromJSONTyped(json, false);
}

export function StemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StemsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(StemFromJSON)),
    };
}

export function StemsResponseToJSON(value?: StemsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(StemToJSON)),
    };
}

